import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch, useSelector } from "react-redux";
import { DialogButton } from "./tv/homePage/components/dialogButton";
import { closeDialog } from "./redux/applicationSlice";
import { useEffect } from "react";

const DialogBox = () => {
    const { dialog } = useSelector((state) => state.application);
    const { ref, focusKey, setFocus } = useFocusable({
        focusKey: "dialog-container",
        isFocusBoundary: true,
        trackChildren: true,
        autoRestoreFocus: true,
    });

    const dispatch = useDispatch();

    const handleClose = () => dispatch(closeDialog());
    const handleConfirm = async () => {
        await dialog?.onConfirm();
        handleClose();
    };

    const handleCancel = async () => {
        await dialog?.onCancel();
        handleClose();
    };

    useEffect(() => {
        if (dialog.show) {
            setFocus('dialog-ok-button');
        }
    }, [dialog.show]);

    if (!dialog.show) return null;

    return (
        <Dialog
            open={dialog.show}
            style={{ backdropFilter: "blur(5px)" }}
            sx={{
                "& .MuiDialog-paper": {
                    outline: "none",
                },
            }}
        >
            <FocusContext.Provider value={focusKey}>
                <Box ref={ref} width={300}>
                    <DialogTitle>Message</DialogTitle>
                    <DialogContent>{dialog.message}</DialogContent>
                    <DialogActions>
                        {dialog.showCanclButton && <DialogButton
                            onClick={handleCancel}
                            color="#e84d31"
                            focusColor="#c0280b"
                            focusKey="dialog-cancel-button"
                        >
                            {dialog?.cancelText ?? "Cancel"}
                        </DialogButton>}
                        <DialogButton
                            onClick={handleConfirm}
                            color="#4285f4"
                            focusColor="primary.main"
                            focusKey="dialog-ok-button"
                        >
                            {dialog?.confirmText ?? "Ok"}
                        </DialogButton>
                    </DialogActions>
                </Box>
            </FocusContext.Provider>
        </Dialog>
    );
};

export default DialogBox;
